import { Message } from '@studio/design-system/prompt';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { Section } from './section.jsx';
import type { ConfirmProps } from './types.js';

/** `<Confirm>` component. */
export const Confirm = ({ className, ...props }: ConfirmProps): ReactElement => (
  <div className={twMerge('ml-20 flex flex-col gap-8', className)} {...props}>
    <Section icon='camera' title='Verify Brand & Model'>
      <Message>
        Make sure you selected the correct brand and model for your camera. Our calibration process
        uses values from the specific model you selected.
      </Message>
    </Section>

    <Section icon='target' title='Avoid Empty Rooms & Walls'>
      <Message>
        Calibration requires objects to be visible by the camera. Really, just make sure the camera
        isn&rsquo;t pointing at a wall or an empty room.
      </Message>
    </Section>

    <Section icon='auto-tracking' title='Prevent Camera Obstructions'>
      <Message>
        Avoid people walking directly in front of the camera for the duration of the calibration.
      </Message>
    </Section>

    <Section icon='tally-light' title='Ensure Adequate Lighting'>
      <Message>
        If you can&rsquo;t see, then the camera can&rsquo;t. Make sure the camera&rsquo;s field of
        view is well lit.
      </Message>
    </Section>
  </div>
);
